import { StirCommonIconsComponent, stirCommonIconsIds } from 'stirista-gui-kit';
import { Component, input } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { loading_toaster_default_strings } from '@shared/components/loading-toaster/strings/default-strings';

type CommonIconId =
  (typeof stirCommonIconsIds)[keyof typeof stirCommonIconsIds];

@Component({
  selector: 'app-loading-toaster',
  templateUrl: './loading-toaster.component.html',
  styleUrls: ['./loading-toaster.component.scss'],
  imports: [ToastModule, ProgressBarModule, StirCommonIconsComponent],
})
export class LoadingToasterComponent {
  /**
   * Icon rendered before the toast summary text.
   * Defaults to the existing error icon to preserve current behavior.
   */
  iconType = input<CommonIconId>(loading_toaster_default_strings.iconType);
}
